// firebaseConfig.js
import { initializeApp }     from "firebase/app";
import { getAnalytics }      from "firebase/analytics";
import { getFirestore }      from "firebase/firestore";
import { getAuth }           from "firebase/auth";
import { getStorage }        from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAUKbaeBtCUcBTE4R9v3gAkuyKLpN6QZWw",
    authDomain: "suitcase-theatre-arcade.firebaseapp.com",
    projectId: "suitcase-theatre-arcade",
    storageBucket: "suitcase-theatre-arcade.firebasestorage.app",
    messagingSenderId: "812684071893",
    appId: "1:812684071893:web:53837ae3b05eab6bffa35c",
    measurementId: "G-8LZSFRC7DC"
};

// Initialize the SDKs
const app       = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db        = getFirestore(app);
const auth      = getAuth(app);
const storage   = getStorage(app);

// Export whatever you need elsewhere
export { app, analytics, db, auth, storage };
